import { useCallback, useRef } from 'react'

// Every field that takes focus on open goes through this, not autoFocus: it
// focuses once, during the tap's own commit (so iOS still raises the keyboard),
// and with preventScroll, so iOS doesn't scroll a sliding sheet's header away
// to reveal the field. SheetPanel keeps the sheet above the keyboard.
// A field that exists only while it is being edited (an inline rename): a
// stable ref callback, so it runs once on mount.
export const focusOnMount = (el: HTMLElement | null) => el?.focus({ preventScroll: true })

export function useAutoFocus<T extends HTMLElement>(enabled = true) {
  const done = useRef(false)
  return useCallback((el: T | null) => {
    if (!el || !enabled || done.current) return
    done.current = true
    el.focus({ preventScroll: true })
  }, [enabled])
}
